import React, { useContext } from 'react'
import { AuthContext } from '../../context/AuthContext'

export function MicrosoftSignIn() {
  const { microsoftSignIn } = useContext(AuthContext)

  async function handleMicrosoftSignIn() {
    try {
      await microsoftSignIn()
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <button
      onClick={handleMicrosoftSignIn}
      className="w-full h-14 rounded-md border border-black flex items-center justify-center space-x-3 hover:bg-gray-50 transition-colors"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" width="24" height="24">
        <path fill="#f35325" d="M0 0h10v10H0z" />
        <path fill="#81bc06" d="M11 0h10v10H11z" />
        <path fill="#05a6f0" d="M0 11h10v10H0z" />
        <path fill="#ffba08" d="M11 11h10v10H11z" />
      </svg>
      <p className="text-black text-base font-medium font-['DM_Sans']">Continue with Microsoft</p>
    </button>
  )
}
